import React from "react";
import PropTypes from "prop-types";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import { getGlobal } from "@/functions/getGlobal";

/**
 *
 * @param path
 * @param tag
 * @param dangerouslySetInnerHTML
 * @param children
 * @param props
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>|JSX.Element}
 * @constructor
 */
export default function DynamicText({ path, tag, dangerouslySetInnerHTML, children, ...props }) {
  let textProps = {
    type: "text",
    global: getGlobal(),
    path,
    children,
  };

  if (dangerouslySetInnerHTML) {
    textProps.children = <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} />;
  }

  if (tag) {
    return React.createElement(tag, props, <SourceFlowText {...textProps} />);
  }

  return <SourceFlowText {...textProps} {...props} />;
}

DynamicText.defaultProps = {
  tag: null,
};

DynamicText.propTypes = {
  path: PropTypes.string.isRequired,
  tag: PropTypes.oneOf(["p", "span", "div", "li", "strong", "b", "i", "h1", "h2", "h3", "h4", "h5", "h6"]),
};
